import React, { useEffect, useState } from 'react'

import {
  CompassOutlined,
  InfoCircleOutlined,
  MailOutlined,
  PhoneOutlined,
  StarOutlined,
  TagOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Avatar, Card, Typography } from 'antd'
import { get } from 'lodash'

import { api, request } from '../../../util/handlerRequestUtil'

import './Header.css'

const Header = function ({ customer, contact, groups }) {
  const [contacts, setContacts] = useState({})
  const [alternatives, setAlternatives] = useState(0)
  const [locations, setLocations] = useState([])

  useEffect(() => {
    if (contact) {
      setContacts(contact)
    }

    if (customer.id) {
      listCustomerLocations(customer.id)
    }
  }, [])

  useEffect(() => {
    if (groups.length > 0) {
      getAlternativesGroup()
    }
  }, [groups])

  async function getAlternativesGroup() {
    try {
      const countPartnerDocuments = groups.reduce((prev, curr) => {
        const { documents = [] } = curr
        return prev + documents.length
      }, 0)
      setAlternatives(countPartnerDocuments)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listCustomerLocations(id, params) {
    if (!id) {
      return
    }
    try {
      const customerLocations = await request(api.listCustomerLocations(id, params), true)
      setLocations(customerLocations)
    } catch (error) {
      console.tron.log(error)
    }
  }

  return (
    <div className="container-header">
      <div className="gradient-bar"></div>

      <div className="main-avatar">
        <div className="container-avatar">
          <div className="default-header-breadcrumb" style={{ flexDirection: 'column' }}>
            <Avatar className="gx-avatar gx-pointer avatar" alt="">
              <span className="content-avatar">
                {customer.name ? customer.name.substr(0, 2).toLocaleUpperCase() : ''}
              </span>
            </Avatar>
          </div>

          <div className="customer-label">
            <Typography.Title className="default-header-title" level={3}>
              {customer.name ? customer.name : ''}
            </Typography.Title>
          </div>

          <div className="customer-info">
            {contacts.contactName ? (
              <Typography style={{ marginRight: 20 }}>
                <UserOutlined style={{ fontSize: 20, marginRight: 5 }} />
                <span>{contacts.contactName}</span>
              </Typography>
            ) : null}

            {contacts.phoneNumber ? (
              <Typography style={{ marginRight: 20 }}>
                <PhoneOutlined style={{ fontSize: 20, marginRight: 5 }} />
                <span>{contacts.phoneNumber}</span>
              </Typography>
            ) : null}

            {contacts.email ? (
              <Typography style={{ marginRight: 20 }}>
                <MailOutlined style={{ fontSize: 20, marginRight: 5 }} />
                <span>{contacts.email}</span>
              </Typography>
            ) : null}

            {contacts.jobRole ? (
              <Typography style={{ marginRight: 20 }}>
                <TagOutlined style={{ fontSize: 20, marginRight: 5 }} />
                <span>{contacts.jobRole}</span>
              </Typography>
            ) : null}
          </div>
        </div>

        <div className="main-cards">
          <Card className="ant-card-bordered card">
            <div className="container-card">
              <InfoCircleOutlined className="icon-card-info" />
              <div className="label-card-info">
                <span>Status</span>
                <span style={{ fontWeight: 'bold' }}>{customer.active ? 'Ativo' : 'Inativo'}</span>
              </div>
            </div>
          </Card>

          <Card className="ant-card-bordered card">
            <div className="container-card">
              <StarOutlined className="icon-card-info" />
              <div className="label-card-info">
                <span>Tipo</span>
                <span style={{ fontWeight: 'bold' }}>
                  {get(customer.customerHasCustomerTypes[0], 'customerType.name', '')}
                </span>
              </div>
            </div>
          </Card>

          <Card className="ant-card-bordered card">
            <div className="container-card">
              <UserOutlined className="icon-card-info" />
              <div className="label-card-info">
                <span>Alternativos</span>
                <span style={{ fontWeight: 'bold' }}>{alternatives}</span>
              </div>
            </div>
          </Card>

          <Card className="ant-card-bordered card">
            <div className="container-card">
              <CompassOutlined className="icon-card-info" />
              <div className="label-card-info">
                <span>Locais</span>
                <span style={{ fontWeight: 'bold' }}>{locations.length}</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Header
